import React from 'react';

const PageHeader = ({ title, subtitle, action }) => {
    return (
        <div className="flex justify-between items-center mb-6 border-b border-slate-800 pb-4">
            <div>
                <h1 className="text-2xl font-bold text-white tracking-tight m-0">{title}</h1>
                {subtitle && <p className="text-sm text-slate-400 mt-1">{subtitle}</p>}
            </div>
            {action && <div>{action}</div>}
        </div>
    );
};

export default PageHeader;
